import { render } from "./ErrorMessage.vue?vue&type=template&id=062dafc6&scoped=true"
import script from "./ErrorMessage.vue?vue&type=script&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&lang=js"

import "./ErrorMessage.vue?vue&type=style&index=0&id=062dafc6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-062dafc6"

export default script